import type { KeyNumberColumn } from "./types";

export const KEY_NUMBERS_COLUMNS: KeyNumberColumn[] = [
  {
    key: "name",
    label: "homePage:keyNumberCategory",
    align: "left",
    getFormattedValue: (r) => r.name,
    cellClassName: "py-[8.25px]",
  },
  {
    key: "nrTenants",
    label: "homePage:keyNumberTenants",
    align: "right",
    getFormattedValue: (r) => r.nrTenants,
    cellClassName: "text-right",
  },
  {
    key: "general",
    label: "homePage:keyNumberGeneral",
    align: "right",
    getFormattedValue: (r) => r.general.toLocaleString(),
    cellClassName: "text-right",
  },
  {
    key: "recycled",
    label: "homePage:keyNumberRecycled",
    align: "right",
    getFormattedValue: (r) => r.recycled.toLocaleString(),
    cellClassName: "text-right",
  },
  {
    key: "recyclingRate",
    label: "homePage:keyNumberRate",
    align: "right",
    getFormattedValue: (r) => r.recyclingRate.toLocaleString(),
    cellClassName: "text-right font-bold",
    unit: "%",
  },
];

export const CATEGORY_NONE = "NONE";
